export default {
    print: {
        issueDelivery: {
            button: 'Печать списка заказов',
            infoTitle: 'Задача на выдачу заказов в доставку {typeText} от {date}',
        },

        tasks: ['Заказ', 'Трек-номер заказа', 'Количество тар в заказе', 'Статус'],
    },

    actual: {
        text: 'Выдача в доставку',

        fields: {
            type: 'Тип задачи',
            priority: 'Приоритет',
            status: 'Статус',
        },

        service: {
            priority: 'Высокий',
            status: 'Не выполнена',
        },
    },

    fieldsView: {
        orderId: 'Заказ',
        pfm: 'Код магазина ПФМ',
        tare: 'Тары в заказе',
        orderStatus: 'Статус',
        printTransfer: 'Передаточные документы',
        partnerOrder: '№ заказа партнёра',
        actions: 'Действие',
    },

    filter: {
        filters: {
            orderId: 'Номер заказа',
            pfm: 'Код магазина ПФМ',
            deliveryServiceTypeId: 'Тип доставки',
        },

        buttonClear: 'Очистить',
    },

    index: {
        actualIssueDelivery: 'Актуальные',
        noActualIssueDelivery: 'Неактуальные',
    },

    view: {
        h2: 'Задача на выдачу заказов в доставку {description}',
        input: 'Код магазина ПФМ',
        button: ['Сформировать АПП', 'Выданы в доставку'],
        tooltip: ['Ни один заказ не выбран', 'Ни один заказ не выбран'],
        printTransferDocs: 'Этикетка',
        titleIssueModal: 'Распечатать этикетку?',
        informationText: 'Распечатать этикетку курьерской службы? После печати заказу присвоится статус "Готов к отгрузке"',
        issueModalOk: 'Печать',
        issueModalCancel: 'Отмена',
        bvModal: 'Распечатать АПП?',
        textForEmit: 'заказу | заказам',
        emit: [
            `По {text} №{ordersWithActs} уже сформирован акт. Исключите заказы с пометкой "акт сформирован" и повторите действие`,
            'Не удалось проверить переданные АПП',
            'Невозможно получить АПП',
        ],
        existActs: 'У вас есть неотгруженные заказы!',
        actButton: 'АПП',
    },
};